import { useEffect, useState } from 'react';
import { Text, FlexContainer, Spinner, Inputs } from '@taxdown/piccolo-web';
import { locizeNS } from 'Services/i18n';
import useTranslation from 'Hooks/useTranslation';
import { useFetchPutNotificationPreference } from '../../hooks';
import * as Styled from './styles';
import { MARKETING_NOTIFICATIONS, TAX_NOTIFICATIONS } from './traits';
import { AccountNotifyProps } from './types';

const AccountNotify = ({ data }: AccountNotifyProps): JSX.Element => {
  const { t } = useTranslation(locizeNS.ACCOUNT);
  const [notifications, setNotifications] = useState({});
  const { mutate } = useFetchPutNotificationPreference();

  const onChangeNotif = (value, notif): void => {
    const updatedNotifications = { ...notifications, [notif]: value };
    setNotifications(updatedNotifications);
    mutate(updatedNotifications);
  };

  useEffect(() => {
    if (data) {
      setNotifications(data);
    }
  }, [data]);

  if (!data) {
    return (
      <FlexContainer justify="center" align="center">
        <Spinner size="M" justify="center" align="center" />
      </FlexContainer>
    );
  }

  return (
    <>
      <Styled.NotificationGroupTitle type="fds_text_semibold_M" color="dark_500" mb="fds_size_24">
        {t('Notifications.header.taxdown')}
      </Styled.NotificationGroupTitle>
      <Styled.StyledContainer direction="column">
        {TAX_NOTIFICATIONS.map(({ name, label }) => (
          <Styled.StyledFlexContainer justify="space-between" align="center" key={name}>
            <Text color="dark_500" type="fds_text_regular_M">
              {t(label)}
            </Text>
            <Inputs.Switcher
              id={name}
              value={notifications[name]}
              onChange={value => onChangeNotif(value, name)}
            />
          </Styled.StyledFlexContainer>
        ))}
      </Styled.StyledContainer>
      <Styled.NotificationGroupTitle type="fds_text_semibold_M" color="dark_500" mb="fds_size_24">
        {t('Notifications.header.marketing')}
      </Styled.NotificationGroupTitle>
      <Styled.StyledContainer direction="column">
        {MARKETING_NOTIFICATIONS.map(({ name, label }) => (
          <Styled.StyledFlexContainer justify="space-between" align="center" key={name}>
            <Text color="dark_500" type="fds_text_regular_M">
              {t(label)}
            </Text>
            <Inputs.Switcher
              id={name}
              value={notifications[name]}
              onChange={value => onChangeNotif(value, name)}
            />
          </Styled.StyledFlexContainer>
        ))}
      </Styled.StyledContainer>
    </>
  );
};

export default AccountNotify;
